import { useAppDispatch } from '@/Application/Hooks/Redux';
import { URL_ROUTES } from '@/constants';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks';
import { setLeavingPayment } from '@/modules/perseo-billing/store/slices/billing';
import { isDeviceAndroid, isDeviceIos } from '@/modules/perseo-billing/utils';

export type EditCartHook = 'summary' | 'shipping';
export const useEditCart = (context?: EditCartHook) => {
  const dispatch = useAppDispatch();
  const { goToCartGtm } = useGtmBillingProduct();
  const onEditCart = () => {
    if (!isDeviceAndroid() && !isDeviceIos()) {
      goToCartGtm(context);
      dispatch(setLeavingPayment(URL_ROUTES.CART));
    }
  };

  return {
    onEditCart
  };
};
